import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EmailField,
  DateField,
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  DateInput,
  Edit,
  EditButton,
  Delete,
  Filter,
  LongTextInput
} from 'admin-on-rest/lib/mui';

export const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput label="name" source="name" alwaysOn/>
    <SelectInput source="type"
      choices={[
        { id: 'captain', name: 'captain' },
        { id: 'crew', name: 'crew' },
      ]}
    />
    <SelectInput
      label="admin"
      source="is_admin"
      choices={[
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' },
      ]}
    />
  </Filter>
);

export const UserList = (props) => (
    <List title="Users" filters={<UserFilter />} {...props}>
        <Datagrid>
          <TextField source="name" />
          <TextField source="type" />
          {/* <TextField source="country" />  */}
          <DateField source="birthdate" />
          <EmailField source="email" />
          <BooleanField source="is_admin" />
          <EditButton />
        </Datagrid>
    </List>
);

export const CreateUser = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="surname" />
    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `` : ''}</span>;
};


export const EditUser = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="surname" />
      <BooleanInput label="admin ?" source="is_admin" />
      <TextInput source="email" type="email" />
      <LongTextInput label="Μηνιαιος τζιρος" source="phone_mon" />
    </SimpleForm>
  </Edit>
);

export const DeleteUser = (props) => <Delete {...props} />;



// WEBPACK FOOTER //
// ./src/pages/users.js